import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import { History } from "lucide-react";

const KIND = {
  create: "Création", update: "Modification", status: "Changement de statut", source_added: "Source ajoutée",
  source_removed: "Source retirée", merge: "Rattachement d'une fiche provisoire", merged_into: "Rattachée à une autre fiche",
  migration: "Mise à jour des statuts",
};
const FIELD = {
  first_name: "Prénom", last_name: "Nom", nickname: "Surnom", gender: "Genre", clan_key: "Famille", birth_year: "Naissance",
  death_year: "Décès", birth_place: "Lieu de naissance", biography: "Biographie", father_id: "Père", mother_id: "Mère",
  spouse_ids: "Conjoints", is_alive: "Vivant", is_provisional: "Provisoire", photo_path: "Photo", verification_status: "Statut",
  origin: "Origine", paternal_origin: "Lignée paternelle", maternal_origin: "Lignée maternelle", cultural_identity: "Identité culturelle",
};

export const HistoryPanel = ({ personId, refreshKey }) => {
  const { API } = useAuth();
  const { t } = useLang();
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/persons/${personId}/history`).then(r => setItems(r.data)).catch(() => setItems([]));
  }, [API, personId, refreshKey]);

  const show = (k, v) => {
    if (v == null || v === "") return "—";
    if (k === "verification_status") return t(v) || v;
    if (typeof v === "object") return Array.isArray(v) ? `${v.length}` : (v.description || "…");
    return String(v).slice(0, 60);
  };

  return (
    <details className="heritage-card p-4 mb-8" data-testid="history-panel">
      <summary className="cursor-pointer label-uppercase text-[#6E5B4F] flex items-center gap-2">
        <History className="w-3.5 h-3.5" /> Historique des modifications ({items.length})
      </summary>
      <ul className="mt-4 space-y-3">
        {items.map(h => (
          <li key={h.id} className="border-l-2 border-[#E3D5CA] pl-3 text-sm" data-testid={`history-${h.id}`}>
            <div className="text-[#261911]"><span className="font-semibold">{KIND[h.kind] || h.kind}</span> · {h.user_name || "—"} · <span className="text-[#6E5B4F]">{h.at?.slice(0, 16).replace("T", " ")}</span></div>
            {Object.entries(h.changes || {}).filter(([k]) => k !== "source").map(([k, c]) => (
              <div key={k} className="text-xs text-[#6E5B4F]">{FIELD[k] || k} : {show(k, c.old)} → {show(k, c.new)}</div>
            ))}
            {h.notes && <div className="text-xs italic text-[#6E5B4F]">« {h.notes} »</div>}
          </li>
        ))}
      </ul>
    </details>
  );
};

export default HistoryPanel;
